export default __webpack_public_path__ + "static/media/AdBugs_04.73a146a6.png";